<div *ngIf="loading"
     class="loading-overlay">
    <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
    <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>

<!-- Formulario Filtro -->
<div class="row">
    <div class="col-12">

        <div class="card border rounded animated fadeIn fast">
            <div class="card-body animated fadeIn fast">

                <!-- cabecera -->
                <div class="row  ">

                    <!-- id_almacen -->
                    <div class="col-2"
                         title="Almacén">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"><i class="fa-solid fa-warehouse"></i></div>
                            <select class="form-control"
                                    [(ngModel)]="almacenSeleccionado"
                                    (ngModelChange)="onCambiaAlmacen()">
                                <option *ngFor="let almacen of almacenesList"
                                        [value]="almacen.id">
                                    {{almacen.nombre}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- cliSeleccionado -->
                    <div class="col-2"
                         title="Cliente">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"><i class="fa-solid fa-user"></i></div>
                            <select class="form-control"
                                    [(ngModel)]="clienteSeleccionado"
                                    (ngModelChange)="onCambiaCliente()">
                                <option *ngFor="let cli of clientesList"
                                        [value]=cli.id>
                                    {{cli.nombre}}
                                </option>
                            </select>
                        </div>
                    </div>


                    <!-- ean -->
                    <div class="col-2"
                         title="EAN">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"><i class="fa-solid fa-barcode"></i></div>
                            <select class="form-control"
                                    [disabled]="listaAnalisis.length === 0"
                                    [(ngModel)]="eanSeleccionado"
                                    (change)="onCambiaEan()">
                                <option [ngValue]="null">Todos</option>
                                <option *ngFor="let ean of eanList"
                                        [value]="ean">
                                    {{ean}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- Severidad -->
                    <div class="col-2"
                         title="Severidad">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"><i class="fa-solid fa-fire"></i></div>
                            <select class="form-control"
                                    [disabled]="listaAnalisis.length === 0"
                                    [(ngModel)]="severidadSeleccionada"
                                    (change)="onSeveridadChange()">
                                <option [ngValue]="null">Todas</option>
                                <option value="alta">Crítica</option>
                                <option value="media">Advertencia </option>
                                <option value="baja">Baja</option>
                            </select>
                        </div>
                    </div>



                    <div class="col-4">
                        <form>

                            <div class="row float-right">

                                <div class="col-sm-6">
                                    <div class="form-group rounded">
                                        <select class="form-control"
                                                name="rowsLimitStr"
                                                [(ngModel)]="rowsLimitStr"
                                                (change)="rowsLimitChange()">
                                            <option [value]="10">10</option>
                                            <option [value]="50">50</option>
                                            <option [value]="100">100</option>
                                            <option [value]="999999">Todo</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group float-right">
                                        <div class="btn-group">

                                            <button type="button"
                                                    (click)="cargarAnalisis()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Recargar datos">
                                                <i class="fa-solid fa-sync"></i>
                                            </button>
                                            <button type="button"
                                                    (click)="exportToExcel()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Descargar Excel">
                                                <i class="fa-solid fa-download"></i>
                                            </button>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                </div>




                <!-- datatable -->
                <h2> Optimización de Espacio</h2>
                <p class="text-muted">Artículos dispersos que pueden consolidarse en menos ubicaciones.</p>

                <div class="rounded border"
                     [hidden]="listaAnalisis.length === 0">
                    <ngx-datatable class="bootstrap"
                                   [rows]="rows"
                                   [limit]="rowsLimit"
                                   [loadingIndicator]="loading"
                                   [columnMode]="ColumnMode.flex"
                                   [headerHeight]="50"
                                   [footerHeight]="50"
                                   [summaryRow]="false"
                                   [summaryHeight]="55"
                                   [summaryPosition]="'bottom'"
                                   [rowHeight]="'auto'"
                                   [messages]="messages"
                                   [reorderable]="true">



                        <!-- foto -->
                        <ngx-datatable-column name=""
                                              [flexGrow]="1"
                                              [width]="50"
                                              [sortable]="false"
                                              [resizeable]="false">
                            <ng-template let-row="row"
                                         ngx-datatable-cell-template>
                                <div class="text-center">
                                    <img [src]="fotoDir +'/articulos/' + row.articulo_foto"
                                         loading="lazy"
                                         alt="Foto"
                                         class="rounded pointer border"
                                         height="25px"
                                         (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + row.articulo_foto)">
                                </div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- articulo -->
                        <ngx-datatable-column name="Ean"
                                              prop="articulo_ean"
                                              [flexGrow]="3"
                                              [minWidth]="150">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <strong>{{ row.articulo_ean }}</strong>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- sku -->
                        <ngx-datatable-column name="Sku"
                                              prop="articulo_sku"
                                              [flexGrow]="4"
                                              [minWidth]="120">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                {{ value }}<br>
                                <small class="text-muted">{{ row.articulo_descripcion }}</small>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- severidad -->
                        <ngx-datatable-column name="Severidad"
                                              prop="severidad"
                                              [flexGrow]="2"
                                              [minWidth]="50">

                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>

                                <!-- Low -->
                                <span *ngIf="row.severidad === 'baja'"
                                      class="estado low">
                                    <i class="fa-solid fa-circle-check"></i>
                                    <span class="estado-label">Baja</span>
                                    <span class="estado-value">{{ row.severidad.baja }}</span>
                                </span>

                                <!-- Warning -->
                                <span class="estado warning"
                                      *ngIf="row.severidad === 'media'">
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                    <span class="estado-label">Advertencia</span>
                                    <span class="estado-value">{{ row.severidad.media }}</span>
                                </span>

                                <!-- Critical -->
                                <span class="estado critical"
                                      *ngIf="row.severidad === 'alta'">
                                    <i class="fa-solid fa-fire"></i>
                                    <span class="estado-label">Crítico</span>
                                    <span class="estado-value">{{ row.severidad.alta }}</span>
                                </span>

                            </ng-template>

                        </ngx-datatable-column>



                        <!-- num_ubicaciones   -->
                        <ngx-datatable-column name="Ocupadas"
                                              prop='num_ubicaciones'
                                              [flexGrow]="2"
                                              [minWidth]="75">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                {{ row.num_ubicaciones }} ubicaciones
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- Stock Total   -->
                        <ngx-datatable-column name="Stock Total"
                                              prop='stock_total'
                                              [flexGrow]="1"
                                              [minWidth]="180">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div class="text-right mr-3">
                                    <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado) + ' Uds.'"></div>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- porcentaje_ocupacion  -->
                        <ngx-datatable-column name="Ocupación"
                                              prop='porcentaje_ocupacion'
                                              [flexGrow]="2"
                                              [minWidth]="90">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div class="progress"
                                     style="height: 20px;">
                                    <div class="progress-bar h-100 text-center"
                                         [ngClass]="row.porcentaje_ocupacion < 30 ? 'bg-danger' : 'bg-warning'"
                                         [style.width.%]="row.porcentaje_ocupacion">
                                        {{ row.porcentaje_ocupacion }}%
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- ahorro_potencial  -->
                        <ngx-datatable-column name="Ahorro Potencial"
                                              prop='ahorro_potencial'
                                              [flexGrow]="2"
                                              [minWidth]="90">
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <span class="badge badge-estado-success">+ {{ row.ahorro_potencial }} ubicaciones libres</span>
                            </ng-template>
                        </ngx-datatable-column>





                        <!-- Acciones -->
                        <ngx-datatable-column name=""
                                              [flexGrow]="1"
                                              [minWidth]="80"
                                              [maxWidth]="110"
                                              [sortable]="false"
                                              [canAutoResize]="false">
                            <ng-template let-row="row"
                                         let-value="value"
                                         ngx-datatable-cell-template>

                                <div ngbDropdown
                                     class="d-inline-block "
                                     container="body">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                            data-toggle="dropdown"
                                            type="button"
                                            style="border-width: 1px;">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left">
                                        <a [routerLink]="['/panel/articulo_edit',row.id_articulo]"
                                           class="link mr-2 dropdown-item"
                                           placement="top"
                                           title="Editar artículo">
                                            <i class="fa-solid fa-pen-to-square"></i> Editar artículo
                                        </a>

                                        <a [routerLink]="['/panel/stock_lista',row.id_articulo]"
                                           class="link mr-2 dropdown-item"
                                           placement="top"
                                           title="Ver stock ubicado del artículo">
                                            <i class="fa-solid fa-layer-group"></i> Ver Stock Ubicado
                                        </a>

                                        <hr style="margin: 0px;">

                                        <a (click)="obtenerPlan(row)"
                                           class="link mr-2 pointer dropdown-item text-success"
                                           title="Pedir plan de compactación">

                                            <i class="fa-solid fa-wand-magic-sparkles"></i>
                                            Pedir Plan
                                        </a>

                                    </div>
                                </div>

                            </ng-template>
                        </ngx-datatable-column>


                    </ngx-datatable>
                </div>


            </div> <!-- /CardBody-->



        </div>
    </div>

</div> <!-- row -->





<!-- Modal Plan Compactación -->
<div *ngIf="mostrarModalPlan"
     class="modal fade show d-block"
     tabindex="-1"
     style="background: rgba(0,0,0,0.5); z-index: 2000;">

    <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">

            <!-- Header -->
            <div class="modal-header">

                <h5 class="modal-title">
                    Plan de Compactación de Stock
                </h5>

                <button type="button"
                        class="close"
                        (click)="mostrarModalPlan = false">
                    <span>&times;</span>
                </button>

            </div>

            <!-- Body -->
            <div class="modal-body"
                 style="max-height: 70vh; overflow-y: auto;">

                <div *ngIf="planMovimientos.length === 0"
                     class="alert alert-warning">
                    No hay movimientos disponibles
                </div>

                <div class="list-group">


                    <!-- Resumen del plan -->
                    <div class="list-group-item border rounded border-primary bg-light mb-3">

                        <div class="row align-items-center">

                            <!-- Icono -->
                            <div class="col-auto">
                                <i class="fa-solid fa-boxes-stacked fa-2x text-secondary"></i>
                            </div>

                            <!-- Datos -->
                            <div class="col">

                                <!-- Cliente -->
                                <div class="fw-bold">
                                    {{ planData?.totales?.cliente?.nombre }}
                                </div>

                                <!-- Artículo -->
                                <div>
                                    <i class="fa fa-barcode"></i> Ean:
                                    <span class="badge bg-secondary">
                                        {{ planData?.totales?.articulo?.ean }}
                                    </span>

                                    <span class="ms-2">
                                        {{ planData?.totales?.articulo?.descripcion }}
                                    </span>
                                </div>

                                <!-- Capacidad -->
                                <div class="small text-muted mt-1">
                                    Capacidad objetivo por ubicación:
                                    <span class="fw-bold text-info">
                                        {{ planData?.totales?.capacidad | number:'1.0-0' }} uds
                                    </span> ·
                                    <span class="fw-bold fa-lg"> {{ planData?.totales?.contaMovimientos | number:'1.0-0' }}</span> movimientos propuestos
                                </div>

                                <!-- Ubicaciones -->
                                <div class="small text-muted mt-1">
                                    <span class="fw-bold fa-lg"> {{ planData?.totales?.total_ubicaciones_origen | number:'1.0-0' }}</span>
                                    ubicaciones origen ·
                                    <span class="fw-bold fa-lg"> {{ planData?.totales?.total_ubicaciones_destino | number:'1.0-0' }}</span>
                                    ubicaciones destino ·
                                    <span class="fw-bold fa-lg"> {{ planData?.totales?.ubicaciones_liberadas | number:'1.0-0' }}</span>
                                    ubicaciones que quedarán liberadas
                                </div>

                            </div>

                        </div>

                    </div>




                    <!-- Movimientos -->

                    <div *ngFor="let item of planMovimientos"
                         class="list-group-item mb-2 border rounded">

                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <div class="fw-bold text-primary">
                                    {{ item.cantidad }} unidades
                                </div>

                                <div class=" ">
                                    Mover {{ item.cantidad }} unidades de
                                    <span [innerHTML]="funcLib.formatUbicacion(item.ubicacion_origen)"
                                          title="{{funcLib.CodUbiDecript(item.ubicacion_origen)}}"></span>
                                    hacia
                                    <span [innerHTML]="funcLib.formatUbicacion(item.ubicacion_destino)"
                                          title="{{funcLib.CodUbiDecript(item.ubicacion_destino)}}"></span>
                                </div>

                            </div>

                            <div>
                                <i class="fas fa-exchange-alt fa-2x text-warning"></i>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer d-flex justify-content-between">

                <!-- Botones izquierda -->
                <div class="d-flex gap-2">

                    <!-- Acción asignar -->
                    <button type="button"
                            class="btn btn-success mr-2"
                            (click)="asignarPlanUsuario()">
                        <i class="fa fa-user-plus mr-1"></i>
                        Asignar a usuario
                    </button>

                    <!-- Acción PDF -->
                    <button type="button"
                            class="btn btn-secondary mr-2"
                            (click)="generarPdfPlan()">
                        <i class="fa fa-file-pdf mr-1"></i>
                        Generar PDF
                    </button>

                </div>

                <!-- Botón derecha -->
                <button type="button"
                        class="btn btn-secondary"
                        (click)="mostrarModalPlan = false">
                    Cerrar
                </button>

            </div>

        </div>
    </div>
</div>


<!-- Fragmentación de stock por clientes -->
<div class="col-12">
    <app-fragmentacion-stock></app-fragmentacion-stock>
</div>


<!-- Modal para mostrar la imagen -->
<div class="modal-overlay"
     *ngIf="imagenSeleccionada"
     (click)="cerrarPopupImagen()">
    <div class="modal-content">
        <img [src]="imagenSeleccionada"
             class="modal-image"
             alt="Imagen seleccionada">
    </div>
</div>